var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "crash-game" },
      [
        _c("div", { staticClass: "return-btn-con" }, [
          _c(
            "button",
            {
              staticClass: "return-btn",
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("c-svg", {
                attrs: {
                  src: "return.svg",
                  width: "21px",
                  height: "21px",
                  fill: "rgb(217, 222, 229)",
                },
              }),
              _c("div", { staticClass: "text" }),
            ],
            1
          ),
        ]),
        _c("ui-game-info", {
          attrs: {
            playersBetSum: _vm.playersBetSum,
            playersCount: _vm.playersCount,
            privateSeed: _vm.privateSeed,
            publicSeed: _vm.publicSeed,
          },
        }),
        _c("div", { staticClass: "crash-game__title" }, [
          _c("i", { staticClass: "crash-game__icon icon icon_file-list-alt" }),
          _c("span", [_vm._v(_vm._s(_vm.currencyTypeLabel) + " Round")]),
          _c("span", { staticClass: "crash-game__id" }, [
            _vm._v("#" + _vm._s(_vm.$route.params.id)),
          ]),
        ]),
        _c("div", { staticClass: "crash-game__content content" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "content__scroll scroll",
              attrs: { scroll: "vertical" },
            },
            [
              _vm._l(_vm.players, function (item, index) {
                return [_c("crash-bet", { key: index, attrs: { bet: item } })]
              }),
            ],
            2
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content__head" }, [
      _c("div", { staticClass: "content__cell" }, [_vm._v("User")]),
      _c("div", { staticClass: "content__cell" }, [_vm._v("Bet")]),
      _c("div", { staticClass: "content__cell" }, [_vm._v("Multipl.")]),
      _c("div", { staticClass: "content__cell" }, [_vm._v("Result")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }